import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initMixpanel, trackEvent } from "../analytics";
import { EventNames } from "../analytics";

/**
 * Tracks page views via Mixpanel using React Router's location object.
 * Automatically initializes Mixpanel on first use.
 */
const useTrackPageViews = () => {
    const location = useLocation();

    useEffect(() => {
        initMixpanel();
        trackEvent(EventNames.PAGE_VIEWED, {
            pathname: location.pathname,
        });
    }, [location.pathname]);
};

export default useTrackPageViews;
